import { Link } from "react-router";
import { LogoMark } from "../ui/Logo";
import { NAV, SERVICES, SITE } from "../../lib/site";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-line bg-surface-2">
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-5 py-14 sm:px-8 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Link to="/" className="inline-flex items-center gap-2.5 rounded-lg focus-visible:outline-2 focus-visible:outline-offset-4">
            <LogoMark />
            <span className="font-display text-base font-semibold text-ink">{SITE.name}</span>
          </Link>
          <p className="mt-4 max-w-xs text-sm text-ink-soft">{SITE.description}</p>
        </div>

        <nav aria-label="Footer">
          <h2 className="eyebrow mb-3">Explore</h2>
          <ul className="flex flex-col gap-2 text-sm">
            {NAV.map((item) => (
              <li key={item.href}>
                <Link to={item.href} className="text-ink-soft transition hover:text-ink">
                  {item.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/privacy" className="text-ink-soft transition hover:text-ink">
                Privacy
              </Link>
            </li>
          </ul>
        </nav>

        <nav aria-label="Services">
          <h2 className="eyebrow mb-3">Services</h2>
          <ul className="flex flex-col gap-2 text-sm">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <Link to={`/services#${s.id}`} className="text-ink-soft transition hover:text-ink">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="border-t border-line">
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-2 px-5 py-6 text-sm text-ink-soft sm:flex-row sm:items-center sm:justify-between sm:px-8">
          <p>
            © {year} {SITE.legalName}. All rights reserved.
          </p>
          <p className="font-mono text-xs">Microsoft Power Platform · Azure · Automation</p>
        </div>
      </div>
    </footer>
  );
}
